module.exports = __webpack_public_path__ + "static/media/3.8127dcd2.png";